// 批算範圍 — what the querent wants read. The astrologer quotes a price + time per scope.
export const SCOPE_OPTIONS = ['流年', '大批'];
